import api from '../../../../helpers/api';
import { HttpResponse } from '../../../../helpers/models/api.model';
import {
  IAverageIncome,
  INeighborhood,
  IValueZones,
  IZoning,
} from '../types/dataLayers.types';

//TODO:
//ADICIONAR TUDO QUE FOR RELATIVO A CONSUMO DE API AQUI DENTRO
//GRADATIVAMENTE, VAMOS IMPLEMENTAR O CLEAN CODE

export const getNeighborhood = (
  cityId: number
): Promise<HttpResponse<INeighborhood[]>> => {
  return api.post(`developer/platform/adsky/shapes/${cityId}`);
};

export const getValueZones = (): Promise<HttpResponse<IValueZones[]>> => {
  return api.post('developer/platform/adsky/value_zone');
};

export const getZoning = (
  city_id: number
): Promise<HttpResponse<IZoning[]>> => {
  return api.post('/developer/platform/adsky/zoning', {
    city_id: String(city_id),
  });
};

export const getMeanFamilyIncome = (
  coordinates: number[][][]
): Promise<HttpResponse<IAverageIncome | IAverageIncome[]>> => {
  return api.post('/developer/platform/family-income/family-income', {
    coordinates,
  });
};
